const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;
const ADMIN_FUNCTION_URL = `${SUPABASE_URL}/functions/v1/secure-files`;

export const ADMIN_SESSION_CHECK_INTERVAL_MS = 30 * 60 * 1000;

export function endAdminSession() {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_logged_in');
}

export async function refreshAdminSession(): Promise<boolean> {
  const token = localStorage.getItem('admin_token');
  if (!token) return false;

  let res: Response;
  try {
    res = await fetch(`${ADMIN_FUNCTION_URL}/admin/refresh`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${ANON_KEY}`,
        'X-Admin-Token': token,
      },
    });
  } catch {
    return true;
  }

  if (res.status === 401) {
    endAdminSession();
    return false;
  }
  if (!res.ok) return true;

  const data = await res.json().catch(() => ({}));
  if (!data.token || typeof data.token !== 'string') return true;
  localStorage.setItem('admin_token', data.token);
  return true;
}
